export type UnitPreference = 'imperial' | 'metric' | 'both'

const LB_TO_KG = 0.453592
const IN_TO_CM = 2.54

export function displayWeight(lbs: number, pref: UnitPreference): string {
  switch (pref) {
    case 'imperial':
      return `${lbs} lb`
    case 'metric':
      return `${(lbs * LB_TO_KG).toFixed(1)} kg`
    case 'both':
      return `${lbs} lb (${(lbs * LB_TO_KG).toFixed(1)} kg)`
  }
}

export function displayHeight(totalInches: number, pref: UnitPreference): string {
  const feet = Math.floor(totalInches / 12)
  const inches = totalInches % 12
  switch (pref) {
    case 'imperial':
      return `${feet}'${inches}"`
    case 'metric':
      return `${Math.round(totalInches * IN_TO_CM)} cm`
    case 'both':
      return `${feet}'${inches}" (${Math.round(totalInches * IN_TO_CM)} cm)`
  }
}

export function displayLoad(loadLbs: number, pref: UnitPreference): string {
  switch (pref) {
    case 'imperial':
      return `${loadLbs.toFixed(1)} lb`
    case 'metric':
      return `${(loadLbs * LB_TO_KG).toFixed(1)} kg`
    case 'both':
      return `${loadLbs.toFixed(1)} lb (${(loadLbs * LB_TO_KG).toFixed(1)} kg)`
  }
}

export function heightToInches(value: number, pref: UnitPreference): number {
  if (pref === 'metric') return Math.round(value / IN_TO_CM)
  return value
}

export function weightToLbs(value: number, pref: UnitPreference): number {
  if (pref === 'metric') return Math.round(value / LB_TO_KG)
  return value
}
